import { Component, Input, OnInit, ViewChild, AfterViewInit, TemplateRef, Injector, Host, Optional } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { ChildParentTalk, IErrorHandler } from '../../data-models/child-parent-talk';
import { FormGroupComponent } from '../form-group/form-group.component';
import { LocalizePipe } from '../../../../pipes/Localize.pipe';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'formError',
    templateUrl: 'error.component.html',
})
export class FormErrorComponent extends ChildParentTalk implements OnInit, IErrorHandler {

    get familyId() { return 'error'; }

    formControl: AbstractControl;
    @Input() text: string;
    @Input() error: string;

    get isError() { return this.isShown; }
    set isError(value) { }

    get isShown() {
        return !!(this.error && this.formControl && !this.formControl.pristine && this.formControl.errors && this.formControl.errors[this.error]);
    }

    constructor(
        @Host() @Optional() private parentGroup: FormGroupComponent,
        @Host() private parentForm: EasyFormComponent,
        private localize: LocalizePipe,
        protected injector: Injector
    ) {
        super(injector);
    }

    ngOnInit() {

        this.tellYourParents();
        this.localizeText();
    }

    localizeText() {
        this.text = this.text || '';
        this.text = this.localize.transform(this.text, this.localizationSource);
    }

    tellYourParents() {
        this.parentGroup && this.parentGroup.takeChild(this);
        this.parentForm && this.parentForm.takeChild(this);
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/error/error.component.ts